<div class="t-content" id="rent-a-car" [ngStyle]="{'margin-bottom': componentResults ? '70px' : '35px'}">
    <div *ngIf="componentResults" class="d-flex justify-content-between align-items-center mb-4 mt-3">
    <div class="d-flex align-items-center" style="gap: 1em;">
        <img src="../../../../../assets/img/app/categories-search-box/car-compact.svg" style="width: 26px" alt="">
        <h3 class="mb-0 ml-2" style="font-family: 'Rubik', serif">Editar búsqueda de rent a car</h3>
    </div>
    <div>
        <button type="button" class="close btn-closed" aria-label="Close" (click)="close()">
          <span aria-hidden="true" style="font-size: 50px !important; font-weight: 100 !important;">&times;</span>
        </button>
    </div>
  </div>

    <div *ngIf="componentResults && loadingData"
       class="loading-container d-flex flex-column align-items-center justify-content-center py-5 mt-3">


    <div class="logo-loading mb-4">
      <img [src]="agencyImagen"
           alt="Logo"
           class="loading-logo animate__animated animate__pulse animate__infinite">
    </div>


    <div class="text-center animate__animated animate__fadeIn">
      <h4 class="text-muted mb-3">Cargando información, gracias por esperar...</h4>


      <div [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1}" class="spinner-border" role="status">
      </div>
    </div>
  </div>

  <form *ngIf="!loadingData" (ngSubmit)="_onSubmit(_form, $event)" [formGroup]="_form" novalidate>
    <div class="d-flex mb-3 mt-3" style="gap: .5em;position: relative">
      <div class="w-100" id="form-destination" >
          <div class="position-relative">
             <ng-container *ngIf="_origin === undefined">



        <input
          matInput
          placeholder="Lugar Recogida"
          style="background-color: white"
          maxlength="20"
          name="origin"
          id="origin"
          class="form-control input-search-box autocomplete-overlay"
          autofocus
          #origin
          formControlName="origin"
          [matAutocomplete]="auto"
        />
        <mat-autocomplete #auto="matAutocomplete"
                          data-autocomplete="rent-a-car"
                          class="custom-autocomplete-overlay-rent-a-car "
                          [displayWith]="displayFn"
                          (optionSelected)="updateMySelectionOrigin($event.option.value)">
          <ng-container *ngIf="originOptions | async as options">
            <ng-container *ngFor="let item of options">
              <ng-container *ngIf="item.type === 'airport'">
                <mat-option disabled style="background-color: #f4f4f4; height: 42px" *ngIf="item.airports && item.airports.length > 0">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center" style="gap: 0.25em">
                      <img src="../../../../assets/icons/search-box/avion_gris.svg" style="width: 35px; height: 35px" />
                      <span class="mt-1" style="font-family: 'Rubik', serif; font-size: 13px !important; font-weight: 600 !important"
                        >Aeropuerto</span
                      >
                    </div>
                    <div>
                      <span style="font-family: 'Rubik', serif; font-size: 11px !important; font-weight: 400 !important"
                        >{{ item.airports.length }} resultados</span
                      >
                    </div>
                  </div>
                </mat-option>
                <ng-container *ngFor="let airport of item.airports">
                  <mat-option [value]="{data: airport, type: item.type}">
                    <div style="margin-left: 2.4em">
                      <p class="mb-0" style="font-family: 'Rubik'; font-size: 14px !important; font-weight: 600 !important; line-height: 1">
                        {{ capitalize(airport.name) }},
                        <span
                          class="mb-0"
                          style="font-family: 'Rubik'; font-size: 12px !important; line-height: 1; font-weight: 400 !important"
                        >
                          {{ capitalize(airport.country_name) }} ({{ airport?.iata }})
                        </span>
                      </p>
                    </div>
                  </mat-option>
                </ng-container>
              </ng-container>
            </ng-container>
            <ng-container *ngFor="let item of options">
              <ng-container *ngIf="item.type === 'city'">
                <mat-option disabled style="background-color: #f4f4f4; height: 42px" *ngIf="options && options.length > 0">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center" style="gap: 0.25em">
                      <img src="../../../../assets/icons/search-box/ubicacion_gris.svg" style="width: 35px; height: 35px" />
                      <span class="mt-1" style="font-family: 'Rubik', serif; font-size: 13px !important; font-weight: 600 !important"
                        >Ubicación</span
                      >
                    </div>
                    <div>
                      <span style="font-family: 'Rubik', serif; font-size: 11px !important; font-weight: 400 !important"
                        >{{ item.cities.length }} resultados</span
                      >
                    </div>
                  </div>
                </mat-option>
                <ng-container *ngFor="let city of item.cities">
                  <mat-option [value]="{data: city, type: item.type}">
                    <div style="margin-left: 2.4em">
                      <p class="mb-0" style="font-family: 'Rubik'; font-size: 14px !important; font-weight: 600 !important; line-height: 1">
                        {{ capitalize(city.city_name) }},
                        <span
                          class="mb-0"
                          style="font-family: 'Rubik'; font-size: 12px !important; line-height: 1; font-weight: 400 !important"
                          >{{ capitalize(city.city_province) }}{{ city.city_province ? "," : "" }} {{ capitalize(city.country_name) }}</span
                        >
                      </p>
                    </div>
                  </mat-option>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>

        </mat-autocomplete>
        </ng-container>



        <span class="help-block text-danger" *ngIf="_form.get('origin').touched && _form.get('origin').hasError('required')"
          >Este campo es obligatorio</span
        >

        <span class="help-block text-danger" *ngIf="_form.get('origin').touched && _form.get('origin').hasError('invalidcountry')"
          >Invalido Formato para el lugar de recogida.</span
        >
        <span class="help-block text-danger" *ngIf="_form.get('origin').touched && _form.get('origin').hasError('invalidDestination')"
          >Invalido Formato para el lugar de recogida seleccione uno de la lista</span
        >

          <ng-container *ngIf="_origin !== undefined">
            <span class="container-input-icon-cancel">
              <input id="origin" name="origin" matInput
                class="form-control input-search-box input-square-container"
                style="background-color: white;" aria-label="origin"
                [value]="originInputValue"
                type="text" readonly />
              <span class="square-class-secondArrival">
                <div class="container-square-secondArrival">
                  <i class="bi bi-x x-icon-cancel" (mouseenter)="isHoveredCancelDate = true"
                    (mouseleave)="isHoveredCancelDate = false" tooltip="Eliminar destino" placement="bottom"
                    (click)="resetOrigin()"></i>
                </div>
              </span>
            </span>
          </ng-container>

          </div>



      </div>

      <div class="w-100" id="form-destination" >
          <div class="position-relative">
            <ng-container *ngIf="destiny === undefined">
              <input
                matInput
                placeholder="Lugar de Retorno"
                style="background-color: white"
                maxlength="20"
                id="destination"
                name="destination"
                [ngStyle]="{'background-color': getStyleBackgroundReturn()}"
                class="form-control input-search-box"
                autofocus
                #destination
                formControlName="destination"
                [matAutocomplete]="auto"
              />
              <mat-autocomplete
                class="mt-2"
                #auto="matAutocomplete"
                [displayWith]="displayFn"
                (optionSelected)="updateMySelectionDestination($event.option.value)"
              >
                <ng-container *ngIf="destinationOptions | async as options">

                <ng-container *ngFor="let item of options">
                  <ng-container *ngIf="item.type === 'airport'">
                    <mat-option disabled style="background-color: #f4f4f4; height: 42px" *ngIf="item.airports && item.airports.length > 0">
                      <div class="d-flex justify-content-between">
                        <div class="d-flex align-items-center" style="gap: 0.25em">
                          <img src="../../../../assets/icons/search-box/avion_gris.svg" style="width: 35px; height: 35px" />
                          <span class="mt-1" style="font-family: 'Rubik', serif; font-size: 13px !important; font-weight: 600 !important"
                            >Aeropuerto</span
                          >
                        </div>
                        <div>
                          <span style="font-family: 'Rubik', serif; font-size: 11px !important; font-weight: 400 !important"
                            >{{ item.airports.length }} resultados</span
                          >
                        </div>
                      </div>
                    </mat-option>
                    <ng-container *ngFor="let airport of item.airports">
                      <mat-option [value]="{data: airport, type: item.type}">
                        <div style="margin-left: 2.4em">
                          <p class="mb-0" style="font-family: 'Rubik'; font-size: 14px !important; font-weight: 600 !important; line-height: 1">
                            {{ capitalize(airport.name) }},
                            <span
                              class="mb-0"
                              style="font-family: 'Rubik'; font-size: 12px !important; line-height: 1; font-weight: 400 !important"
                            >
                              {{ capitalize(airport.country_name) }} ({{ airport?.iata }})
                            </span>
                          </p>
                        </div>
                      </mat-option>
                    </ng-container>
                  </ng-container>
                </ng-container>

                  <ng-container *ngFor="let item of options">
                    <ng-container *ngIf="item.type === 'city'">
                      <mat-option disabled style="background-color: #f4f4f4; height: 42px" *ngIf="options && options.length > 0">
                        <div class="d-flex justify-content-between">
                          <div class="d-flex align-items-center" style="gap: 0.25em">
                            <img src="../../../../assets/icons/search-box/ubicacion_gris.svg" style="width: 35px; height: 35px" />
                            <span class="mt-1" style="font-family: 'Rubik', serif; font-size: 13px !important; font-weight: 600 !important"
                              >Ubicación</span
                            >
                          </div>
                          <div>
                            <span style="font-family: 'Rubik', serif; font-size: 11px !important; font-weight: 400 !important"
                              >{{ item.cities.length }} resultados</span
                            >
                          </div>
                        </div>
                      </mat-option>
                      <ng-container *ngFor="let city of item.cities">
                        <mat-option [value]="{data: city, type: item.type}">
                          <div style="margin-left: 2.4em">
                            <p
                              class="mb-0"
                              style="font-family: 'Rubik'; font-size: 14px !important; font-weight: 600 !important; line-height: 1"
                            >
                              {{ capitalize(city.city_name) }},
                              <span
                                class="mb-0"
                                style="font-family: 'Rubik'; font-size: 12px !important; line-height: 1; font-weight: 400 !important"
                                >{{ capitalize(city.city_province) }}{{ city.city_province ? "," : "" }}
                                {{ capitalize(city.country_name) }}</span
                              >
                            </p>
                          </div>
                        </mat-option>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </mat-autocomplete>
              <span class="help-block text-danger" *ngIf="_form.get('destination').touched && _form.get('destination').hasError('required')"
                >This field is required.</span
              >
              <span class="help-block text-danger">&nbsp;</span>

              <span
                class="help-block text-danger"
                *ngIf="_form.get('destination').touched && _form.get('destination').hasError('invalidcountry')"
                >Invalido Formato para el lugar de devolucón.</span
              >
              <span
                class="help-block text-danger"
                *ngIf="_form.get('destination').touched && _form.get('destination').hasError('invalidDestination')"
                >Invalido Formato para el lugar de devolución sleccione uno de la lista</span
              >
            </ng-container>

          <ng-container *ngIf="destiny !== undefined">
            <span class="container-input-icon-cancel">
              <input id="destiny" name="destiny" matInput
                class="form-control input-search-box input-square-container"
                style="background-color: white;" aria-label="destiny"
                [value]="destinyInputValue"
                type="text" readonly />
              <span class="square-class-secondArrival">
                <div class="container-square-secondArrival">
                  <i class="bi bi-x x-icon-cancel" (mouseenter)="isHoveredCancelDate = true"
                    (mouseleave)="isHoveredCancelDate = false" tooltip="Eliminar destino" placement="bottom"
                    (click)="resetDestiny()"></i>
                </div>
              </span>
            </span>
          </ng-container>
          </div>
        </div>

      <div style="width: 60%">
        <div class="position-relative">
          <input
            type="hidden"
            id="datePicker"
            #dateRangePicker
            formControlName="dateStarEnd"
            autocomplete="off"
            (change)="change($event)"
            class="form-control input-search-box"
            ngxDaterangepickerMd
            [locale]="{ format: 'DD/MM/YYYY', displayFormat: 'DD/MM/YYYY' }"
            startKey="start"
            endKey="end"
            [(ngModel)]="dateRange"
            [showRangeLabelOnInput]="false"
            [linkedCalendars]="true"
            [closeOnAutoApply]="true"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [autoApply]="true"
            (startDateChanged)="startDateClicked($event)"
            (endDateChanged)="endDateClicked($event)"
            (click)="openDatePicker()"
          />
            <input
              formControlName="dateStar"
              placeholder="Fecha retiro"
              class="form-control input-search-box ngx-daterangepicker-action"
              #dateStart
              id="dateStart"
              readonly
              type="text"
              (click)="openDatepicker('first')"
            />
        </div>
      </div>

       <div style="width: 40%">
        <div class="position-relative">
           <select
              class="form-control input-search-box"
              formControlName="hourOrigin"
              style="padding: 0px 0px !important; font-weight: 500; color: #868e9d !important; font-size: 15px; font-family: 'Poppins'"
            >
              <!-- <option  value="" disabled selected>H.Retiro </option>-->
              <option *ngFor="let hour of times; index as i" [value]="hour.value" style="padding: 0px 0px !important">
                {{ hour.label }}
              </option>
            </select>
        </div>
      </div>

      <div style="width: 60%">
        <div class="position-relative">
           <input
            type="hidden"
            readonly
            [lockStartDate]="true"
            formControlName="dateStarEnd"
            autocomplete="off"
            (change)="change($event)"
            class="form-control input-search-box "
            ngxDaterangepickerMd
            [locale]="{ format: 'DD/MM/YYYY', displayFormat: 'DD/MM/YYYY' }"
            startKey="start"
            endKey="end"
            [(ngModel)]="dateRange"
            [showRangeLabelOnInput]="false"
            [linkedCalendars]="true"
            [closeOnAutoApply]="true"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [autoApply]="true"
            (startDateChanged)="startDateClicked($event)"
            (endDateChanged)="endDateClicked($event)"
            id="datePicker_"
            #datePicker_
          />
          <input
            formControlName="dateEnd"
            placeholder="Fecha devolución"
            class="form-control input-search-box ngx-daterangepicker-action"
            type="text"
            #dateEnd
            id="dateEnd"
            readonly
            (click)="openDatepicker('last')"
          />
        </div>
      </div>

      <div style="width: 40%;">
        <div class="position-relative">
          <select
            class="form-control input-search-box"
            formControlName="hourDestination"
            style="padding: 0px 0px !important; font-weight: 500; color: #868e9d !important; font-size: 15px; font-family: 'Poppins'"
            >
            <option *ngFor="let hour of times; index as i" [value]="hour.value" style="padding: 0px 0px !important">
              {{ hour.label }}
            </option>
          </select>
        </div>
      </div>






    </div>

      <div class="d-flex mb-3 mt-3" style="gap: .5em;">

        <div class="d-flex align-items-center" id="form-destination" style="width: 95%">
          <div class="position-relative">
            <div class="checkbox" >
              <label style="display: flex;align-items: center;">
                <input
                  formControlName="returnDestinations"
                  type="checkbox"
                  (click)="changueReturnDestinations()"
                  [checked]="!returnDestinations"
                />
                <span class="cr">
                  <i class="cr-icon fas fa-check"></i>
                </span>
                <label style="font-family: 'Poppins', sans-serif; font-size: 14px; font-weight: 500;padding-left: 0;margin-bottom: 0;">Retornar en otra Ubicación</label>
              </label>
            </div>
          </div>
        </div>
        <div class="w-100" id="form-destination" >
          <div class="position-relative pl-2">
            <ng-container *ngIf="selectNationalityName === ''">
              <input

                    id="nationality"
                    name="nationality"
                    formControlName="nationality"
                    matInput
                    class="form-control input-search-box"
                    style="background-color: white;"
                    (input)="filterCountries($event.target.value)"
                    (focus)="getCountries()"
                    aria-label="nationality"
                    [matAutocomplete]="auto"
                    placeholder="Nacionalidad"
                    type="text"
              />
              <mat-autocomplete

                                  id="matCountry"
                                  #matCountry
                                  #auto="matAutocomplete"
                                  [displayWith]="displayCountry"
                                  (optionSelected)='updateMySelectionNationality($event.option.value)'>
                <mat-option *ngFor="let country of filteredCountries"
                style="font-family: 'Poppins', sans-serif;padding: 0px 10px !important; height: 35px !important;"
                [value]="country.country_code">
                {{ country.country_name }}</mat-option>
              </mat-autocomplete>
            </ng-container>

            <ng-container *ngIf="selectNationalityName !== ''">
              <span class="container-input-icon-cancel" style="position: relative">
                <input
                      id="nationality"
                      name="nationality"
                      matInput

                      class="form-control input-search-box input-square-container"
                      style="background-color: white;"
                      aria-label="nationality"
                      value="{{selectNationalityName}}"
                      type="text"
                      readonly
                />
                <span  class="square-class-secondArrival">
                  <div class="container-square-secondArrival">
                    <i class="bi bi-x x-icon-cancel"
                      (mouseenter)="isHoveredCancelDate = true" (mouseleave)="isHoveredCancelDate = false"
                      tooltip="Eliminar nacionalidad"
                      placement="bottom"
                      (click)="resetNationality()"
                      ></i>
                  </div>
                </span>
              </span>
            </ng-container>
              <span style="color:red; font-family: 'Poppins';font-size: 10px !important;position: absolute; bottom: -16px;left:10px;line-height: 1"
                  *ngIf="_form.get('nationality')?.touched && _form.get('nationality')?.hasError('required')">
              Este campo es requerido.
            </span>
          </div>
        </div>

        <div class="w-100" id="form-destination" >
          <div class="position-relative">
              <input
              ngui-datetime-picker
              formControlName="age"
              type="number"
              class="form-control input-search-box"
              style="padding: 0 !important; padding-left: 15px !important; padding-right: 6px !important;"
              id="age"
              placeholder="Edad del conductor"
              min="20"
              max="99"
              [(ngModel)]="ageDefault"
              autocomplete="off"
              (input)="limitAgeLength($event)"
            />
            <span style="color:red; font-family: 'Poppins';font-size: 10px !important;position: absolute; bottom: -26px;left:10px;line-height: 1" *ngIf="messageValidateAge">
              {{messageValidateAge}}
            </span>
          </div>
        </div>

        <div class="w-100">
          <div class="position-relative">
            <button
                class="btn btn-search-car d-flex justify-content-center align-items-center w-100"
                type="submit"
                [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"

              >
              <i class="{{ _findData ? 'fa fa-spinner fa-spin fa-sm' : '' }}"></i>
              Buscar
            </button>
          </div>
        </div>

      </div>

  </form>
</div>
